module.exports = {
	"list": "\\e600",
	"filter": "\\e69c",
	"resource": "\\e602",
	"share": "\\e61a",
	"wifi": "\\e6f2",
	"calendar": "\\e62d",
	"play": "\\e604",
	"left": "\\e697",
	"email": "\\e69f",
	"up": "\\e6a5",
	"down": "\\e6a6",
	"right": "\\e6a7",
	"plus": "\\e6b9",
	"picture-fill": "\\e72c",
	"edit": "\\e644",
	"backward": "\\e74d",
	"forward": "\\e74e",
	"user": "\\e61f",
	"upload": "\\e75d",
	"minus": "\\e6fe",
	"ok": "\\e650",
	"search": "\\e6b4",
	"store": "\\e7d7",
	"round-down": "\\e6c9",
	"round-right": "\\e6cd",
	"redio-checked": "\\e71f",
	"redio": "\\e72f",
	"key": "\\e65c",
	"resize-full": "\\e645",
	"sharp": "\\e726",
	"round-left": "\\e689",
	"round-up": "\\e68d",
	"remove": "\\e755",
	"picture": "\\e7b7",
	"home": "\\e6b5",
	"list-circle": "\\e60d",
	"text": "\\e607",
	"location": "\\e73a",
	"exit": "\\e7cb",
	"preview": "\\e617",
	"team": "\\e89f",
	"chat-trend": "\\e625",
	"loading": "\\e648",
	"setting": "\\e60c",
	"close": "\\e7dc",
	"lock": "\\e701",
	"checkbox": "\\e64c",
	"link": "\\e628",
	"change": "\\e620",
	"date": "\\e7a7",
	"checkbox-checked": "\\e61b"
};


//////////////////
// WEBPACK FOOTER
// ./example/icon_test/icon.json
// module id = 226
// module chunks = 0